import React, { useEffect } from 'react';
import Hamburger from '../components/Hamburger';
import FeatureFlagToggle from '../components/FeatureFlagToggle';

export default function Admin() {
    useEffect(() => {
        // Apply dark theme on mount
        const isDark = localStorage.getItem('darkTheme') === 'true';
        if (isDark) {
            document.body.classList.add('dark-theme');
        }
    }, []);
    return (
        <div className="container-fluid py-2 py-md-4">
            <nav className="navbar">
                <Hamburger />
            </nav>
            
            {/* Header Section */}
            <div className="row mb-4">
                <div className="col-12">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                        <div>
                            <h1 className="mb-2 fs-3 fs-md-2">
                                <i className="bi bi-gear-fill me-2 text-primary"></i>
                                Admin Panel
                            </h1>
                            <p className="text-muted mb-0">
                                Manage application settings and feature flags
                            </p>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <span className="badge bg-warning text-dark">
                                <i className="bi bi-shield-lock-fill me-1"></i>
                                Protected Area
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Admin Content */}
            <div className="row">
                <div className="col-12">
                    {/* Feature Flags Section */}
                    <div className="mb-4">
                        <FeatureFlagToggle />
                    </div>

                    {/* Future Admin Features */}
                    <div className="card">
                        <div className="card-header">
                            <h5 className="mb-0">🔧 Additional Admin Tools</h5>
                            <small className="text-muted">More administrative features coming soon</small>
                        </div>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="d-flex align-items-center p-3 border rounded bg-light">
                                        <div className="me-3">
                                            <i className="bi bi-database-fill text-primary fs-4"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-1">Database Management</h6>
                                            <small className="text-muted">Coming Soon</small>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="d-flex align-items-center p-3 border rounded bg-light">
                                        <div className="me-3">
                                            <i className="bi bi-people-fill text-success fs-4"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-1">User Management</h6>
                                            <small className="text-muted">Coming Soon</small>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="d-flex align-items-center p-3 border rounded bg-light">
                                        <div className="me-3">
                                            <i className="bi bi-graph-up text-info fs-4"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-1">Analytics</h6>
                                            <small className="text-muted">Coming Soon</small>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="d-flex align-items-center p-3 border rounded bg-light">
                                        <div className="me-3">
                                            <i className="bi bi-file-text-fill text-warning fs-4"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-1">System Logs</h6>
                                            <small className="text-muted">Coming Soon</small>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="d-flex align-items-center p-3 border rounded bg-light">
                                        <div className="me-3">
                                            <i className="bi bi-shield-check text-danger fs-4"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-1">Security Settings</h6>
                                            <small className="text-muted">Coming Soon</small>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="d-flex align-items-center p-3 border rounded bg-light">
                                        <div className="me-3">
                                            <i className="bi bi-cloud-arrow-up text-primary fs-4"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-1">Backup & Restore</h6>
                                            <small className="text-muted">Coming Soon</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}